<template>
  <div id="documentosView">
    <header class="vm-appbar">
      <router-link to="/" class="vm-mark">
        <img
          class="vm-logo"
          src="../assets/images/logo-videomedi.png"
          alt="Videomedi"
        />
      </router-link>

      <div
        id="vm-appbar-menu"
        class="vm-appbar-menu"
        :class="{ 'is-open': menuOpen }"
      >
        <nav class="vm-appnav">
          <router-link to="/" exact active-class="is-active">
            Início
          </router-link>
          <router-link
            :to="{ path: '/', query: { buscar: '1' } }"
            active-class="is-active"
          >
            Buscar profissionais de saúde
          </router-link>
          <router-link to="/consultas" active-class="is-active">
            Minhas consultas
          </router-link>
          <router-link to="/documentos" active-class="is-active">
            Documentos
          </router-link>
          <router-link to="/meus-pagamentos" active-class="is-active">
            Pagamentos
          </router-link>
        </nav>

        <span class="vm-appbar-spacer" />
      </div>
      <!-- <router-link
        :to="{ path: '/', query: { buscar: '1' } }"
        class="btn btn--accent btn--sm"
      >
        Agendar consulta
      </router-link> -->
      <span class="appbar-icon" aria-label="Notificações">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path
            d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10.3 21a1.94 1.94 0 0 0 3.4 0"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
        <!-- <span class="dot" /> -->
      </span>
      <AppBarUserMenu />

      <button
        type="button"
        class="navbar-toggler vm-appbar-toggler"
        :class="menuOpen ? 'not-collapsed' : 'collapsed'"
        aria-controls="vm-appbar-menu"
        :aria-expanded="menuOpen ? 'true' : 'false'"
        :aria-label="menuOpen ? 'Fechar menu' : 'Abrir menu'"
        @click="menuOpen = !menuOpen"
      >
        <div class="animated-icon">
          <span />
          <span />
          <span />
          <span />
        </div>
      </button>
    </header>

    <div class="area">
      <VerificationPendingBanner />

      <div class="area-head">
        <div>
          <h1 class="greet">Documentos</h1>
          <p class="sub">
            Receitas, atestados e pedidos de exame das suas consultas — sempre
            disponíveis.
          </p>
        </div>
      </div>

      <div class="tabs">
        <span
          v-for="f in filters"
          :key="f.key"
          class="tab"
          :class="{ 'tab--active': activeFilter === f.key }"
          style="cursor:pointer"
          @click="activeFilter = f.key"
        >
          {{ f.label }}
          <template v-if="countFor(f.key)">· {{ countFor(f.key) }}</template>
        </span>
      </div>

      <div v-if="!loading && documents.length === 0" class="state-box">
        <div class="ill">
          <svg width="34" height="34" viewBox="0 0 24 24" fill="none">
            <path
              d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linejoin="round"
            />
            <path
              d="M14 2v6h6M9 13h6M9 17h4"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </div>
        <h3>{{ emptyMessage.title }}</h3>
        <p>{{ emptyMessage.body }}</p>
        <router-link to="/consultas" class="btn btn--outline btn--sm">
          Ver minhas consultas
        </router-link>
      </div>

      <div v-if="!loading && documents.length > 0" class="card card--flush">
        <div class="doc-files">
          <div
            v-for="doc in documents"
            :key="`${doc._type}-${doc.id}`"
            class="docfile"
          >
            <div class="doc-type">
              <div
                class="ic"
                :class="
                  doc._type === 'receita'
                    ? 'ic--rx'
                    : doc._type === 'atestado'
                    ? 'ic--at'
                    : 'ic--ex'
                "
              >
                <svg
                  v-if="doc._type === 'receita'"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M9 13h6M9 17h4M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14 2v6h6"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linejoin="round"
                  />
                </svg>
                <svg
                  v-else-if="doc._type === 'atestado'"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M9 11l3 3L22 4"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <svg
                  v-else
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2v-4M9 21H5a2 2 0 0 1-2-2v-4m0 0h18"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <span
                v-if="activeFilter === 'todos'"
                class="badge badge--no-dot"
                :class="
                  doc._type === 'receita'
                    ? 'badge--info'
                    : doc._type === 'atestado'
                    ? 'badge--success'
                    : ''
                "
              >
                {{
                  doc._type === "receita"
                    ? "Receita"
                    : doc._type === "atestado"
                    ? "Atestado"
                    : "Exame"
                }}
              </span>
            </div>

            <div class="info">
              <b>
                <span v-b-tooltip.hover.top="docTitle(doc)" class="doc-title">
                  {{ shortDocTitle(doc) }}
                </span>
                <span
                  v-if="doc._type === 'receita' && doc.signed === false"
                  class="badge badge--warning badge--no-dot"
                >
                  Não assinada digitalmente
                </span>
              </b>
              <span class="num">
                {{ formatDate(doc.prescription_date || doc.created_at) }}
              </span>
            </div>

            <div class="acts">
              <button
                type="button"
                class="btn btn--ghost btn--sm"
                @click="openDocument(doc)"
              >
                Ver
              </button>
              <button
                v-if="doc.links || doc.file_url"
                class="btn btn--outline btn--sm"
                @click="downloadFile(doc)"
              >
                Baixar
              </button>
            </div>
          </div>
        </div>
      </div>

      <list-pagination
        v-if="!loading && documents.length > 0"
        :page="currentPage"
        :total="totalForTab"
        label="documentos"
        @change="goToPage"
      />

      <div class="card icp-notice">
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          style="flex-shrink:0;color:var(--color-primary)"
        >
          <path
            d="M12 2l8 4v5c0 5-3.5 9-8 11-4.5-2-8-6-8-11V6z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M9 12l2 2 4-4"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span>
          Documentos assinados digitalmente têm certificação ICP-Brasil e código
          de validação no rodapé. Receitas marcadas como "Não assinada
          digitalmente" não possuem essa validade jurídica.
        </span>
      </div>
    </div>

    <footer class="foot-mini">
      <router-link to="/" class="vm-mark">
        <img
          class="vm-logo vm-logo--sm"
          src="../assets/images/logo-videomedi.png"
          alt="Videomedi"
        />
      </router-link>
      <span class="cpy">© 2026 Videomedi · CNPJ 00.000.000/0001-00</span>
      <div class="links">
        <a href="#">Privacidade</a>
        <a href="#">Termos de Uso</a>
        <a href="#">LGPD</a>
        <a href="#">Suporte</a>
      </div>
    </footer>

    <document-view-modal ref="documentViewModal" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AppBarUserMenu from "../components/AppBarUserMenu.vue";
import VerificationPendingBanner from "../components/VerificationPendingBanner.vue";
import DocumentViewModal from "../components/DocumentViewModal.vue";
import ListPagination from "../components/ListPagination.vue";

// Título (descrição/medicamentos) é cortado na lista — o texto completo aparece
// no tooltip do Bootstrap Vue, como na descrição de exames da lista de consultas.
const TITLE_MAX = 20;

export default {
  name: "DocumentosView",
  components: {
    AppBarUserMenu,
    VerificationPendingBanner,
    DocumentViewModal,
    ListPagination
  },

  data() {
    return {
      activeFilter: "todos",
      currentPage: 1,
      filters: [
        { key: "todos", label: "Todos" },
        { key: "receitas", label: "Receitas" },
        { key: "atestados", label: "Atestados" },
        { key: "exames", label: "Exames" }
      ],
      loading: false,
      menuOpen: false
    };
  },

  mounted() {
    document.body.className = "";
    document.body.classList.add("Base");
    this.fetchDocuments();
  },

  methods: {
    async fetchDocuments() {
      this.loading = true;
      await this.$store
        .dispatch("prescriptions/fetchPatientDocuments", {
          filterKey: this.activeFilter,
          page: this.currentPage
        })
        .finally(() => {
          this.loading = false;
        });
    },

    goToPage(page) {
      this.currentPage = page;
      this.fetchDocuments();
    },

    countFor(key) {
      return this.patientDocumentCounts[key] || 0;
    },

    formatDate(value) {
      if (!value) return "";
      return new Date(value).toLocaleDateString("pt-BR");
    },

    docTitle(doc) {
      if (doc._type === "receita") return this.prescriptionTitle(doc);
      if (doc._type === "atestado") return doc.description || "Atestado médico";
      return doc.description || "Pedido de exame";
    },

    shortDocTitle(doc) {
      const title = this.docTitle(doc);
      return title.length > TITLE_MAX
        ? `${title.slice(0, TITLE_MAX)}...`
        : title;
    },

    prescriptionTitle(doc) {
      const names = (doc.drugs || []).map(d => d.name).filter(Boolean);
      return names.length ? names.join(", ") : "Memed · assinada digitalmente";
    },

    openDocument(doc) {
      this.$refs.documentViewModal.open(doc, () => this.refreshDocument(doc));
    },

    async refreshDocument(doc) {
      await this.$store.dispatch("prescriptions/fetchPatientDocuments", {
        filterKey: this.activeFilter,
        page: this.currentPage
      });
      return this.patientDocuments.find(
        d => d.id === doc.id && d._type === doc._type
      );
    },

    async downloadFile(doc) {
      const url = doc.links || doc.file_url;
      const filename = url.split("/").pop();
      try {
        const response = await fetch(url);
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = filename;
        a.click();
        URL.revokeObjectURL(blobUrl);
      } catch {
        window.open(url, "_blank");
      }
    }
  },

  computed: {
    ...mapGetters("prescriptions", [
      "patientDocuments",
      "patientDocumentCounts"
    ]),
    documents() {
      return this.patientDocuments;
    },
    totalForTab() {
      return this.countFor(this.activeFilter);
    },
    emptyMessage() {
      const messages = {
        receitas: {
          title: "Nenhuma receita disponível",
          body:
            "Receitas emitidas pelo profissional de saúde durante a consulta aparecerão aqui."
        },
        atestados: {
          title: "Nenhum atestado disponível",
          body:
            "Atestados emitidos pelo profissional de saúde durante a consulta aparecerão aqui."
        },
        exames: {
          title: "Nenhum pedido de exame disponível",
          body:
            "Pedidos de exame emitidos pelo profissional de saúde durante a consulta aparecerão aqui."
        }
      };
      return (
        messages[this.activeFilter] || {
          title: "Nenhum documento disponível",
          body:
            "Receitas e atestados emitidos pelo profissional de saúde durante a consulta aparecerão aqui."
        }
      );
    }
  },

  watch: {
    activeFilter() {
      this.currentPage = 1;
      this.fetchDocuments();
    },
    $route() {
      this.menuOpen = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.vm-logo {
  display: block;
  height: 28px;
  width: auto;
}

.vm-logo--sm {
  height: 20px;
}

#documentosView {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: var(--color-bg-page);
}

.appbar-icon {
  width: 40px;
  height: 40px;
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-gray-500);
  cursor: pointer;
  flex-shrink: 0;
  position: relative;
  transition: background 0.12s, color 0.12s;

  &:hover {
    background: var(--color-gray-100);
    color: var(--color-gray-800);
  }

  .dot {
    position: absolute;
    top: 7px;
    right: 8px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--color-accent);
    border: 2px solid #fff;
  }
}

.vm-appbar-menu {
  display: contents;
}

.vm-appbar-toggler {
  display: none;

  .animated-icon span {
    background: var(--color-gray-600) !important;
  }
}

@media (max-width: 991px) {
  .vm-appbar {
    gap: var(--space-2);
    padding: 0 var(--space-4);
  }

  .vm-appbar .vm-mark {
    margin-right: auto;
  }

  .vm-appbar-toggler {
    display: block;
  }

  .vm-appbar-menu {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 100;
    flex-direction: column;
    gap: var(--space-4);
    padding: var(--space-4);
    background: #fff;
    border-bottom: 1px solid var(--color-gray-200);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.06);

    &.is-open {
      display: flex;
    }
  }

  .vm-appnav {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--space-4);
  }

  .vm-appbar-spacer {
    display: none;
  }
}

// Aviso ICP-Brasil — único estilo local desta view
.icp-notice {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-4);
  background: var(--color-primary-light);
  border-color: transparent;
  font-size: var(--font-size-xs);
  color: var(--color-gray-600);
  line-height: 1.5;
}

// Layout e componentes usam as classes globais de _patient-shell.scss:
// .area, .area-head, .greet, .tabs, .tab, .tab--active, .state-box, .ill, .foot-mini

.doc-files {
  display: flex;
  flex-direction: column;
}

// Rodapé de paginação — mesmo padrão do .fin-footer do Extrato financeiro.
.docfile {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: var(--space-4);
  align-items: center;
  padding: var(--space-4) var(--space-5);
  border-bottom: 1px solid var(--color-gray-100);

  &:last-child {
    border-bottom: none;
  }
}

// Título encurtado herda o tamanho/cor do <b> — sem isso cai na regra global
// `.docfile .info span` (da data) e fica menor e cinza.
.docfile .info .doc-title {
  font-size: inherit;
  color: inherit;
}

// Ícone com a tag do tipo (Exame/Receita/Atestado) logo abaixo — tira a tag da
// linha do título, onde ela empurrava o botão "Ver".
.doc-type {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-1);
}

.ic {
  width: 44px;
  height: 44px;
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  &.ic--rx {
    background: var(--color-primary-light);
    color: var(--color-primary);
  }

  &.ic--ex {
    background: var(--color-accent-light, #fce7f1);
    color: var(--color-accent);
  }

  &.ic--at {
    background: var(--color-success-light, #e6f4ea);
    color: var(--color-success, #2e7d32);
  }
}

.info {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);

  b {
    font-size: var(--font-size-sm);
    color: var(--color-gray-900);
    display: flex;
    align-items: center;
    gap: var(--space-2);
  }

  .num {
    font-size: var(--font-size-xs);
    color: var(--color-gray-500);
  }
}

.acts {
  display: flex;
  gap: var(--space-2);
  flex-shrink: 0;
}

.badge--no-dot::before {
  display: none;
}
</style>
